export const normalizeAreaName = (str) => {
    if (!str) return '';
    return str
        .replace(/ونش-انقاذ-/g, '')
        .replace(/ونش انقاذ /g, '')
        .replace(/-/g, ' ')
        .replace(/[أإآ]/g, 'ا')
        .replace(/ة/g, 'ه')
        .replace(/[يى]/g, 'ي')
        .replace(/\s+/g, ' ')
        .trim();
};

export const toAreaSlug = (str) => {
    if (!str) return '';
    return str
        .trim()
        .replace(/\s+/g, '-');
};
